module.exports = __webpack_public_path__ + "static/media/shadow_mobile_journey.6a07a9b6.png";